<template>
  <div
    class="form-group"
    :class="wrapperClass"
  >
    <label
      v-if="hasLabel"
      :class="labelClass"
      :for="cmpId"
    >
      {{ label }}
      <slot/>
    </label>

    <textarea
      v-if="!isStatic"
      :id="cmpId"
      v-bind="inputAttrs"
      :aria-describedby="ariaDescribedBy"
      :class="formControlClasses"
      :disabled="disabled"
      :placeholder="placeholder"
      :readonly="readonly"
      :rows="rows"
      :value="modelValue"
    />
    <p
      v-if="isStatic"
      class="form-control-plaintext"
    >
      {{ modelValue }}
    </p>

    <div
      v-if="helpBlock"
      :id="ariaDescribedBy"
      class="form-text small"
    >
      {{ helpText }}
    </div>

    <!-- @slot Space for overriding custom validation feedback -->
    <slot name="validationFeedback">
      <div
        v-if="validationFeedbackText"
        :class="validationFeedbackClass"
      >
        {{ validationFeedbackText }}
      </div>
    </slot>
  </div>
</template>

<script>
import formControl from '../../mixins/form-control';
import formControlText from '../../mixins/form-control-text';

export default {
  name: 'DpTextarea',

  mixins: [formControlText, formControl],

  props: {
    formControlClass: {
      type: [String, Array, Object],
      required: false,
      default: '',
    },
    rows: {
      type: [Number, String],
      required: false,
      default: 3,
    },
  },

  emits: [
    'update:modelValue',
  ],

  methods: {
    input(event) {
      /**
       * Emits textarea value
       *
       * @type {text}
       */
      this.$emit('update:modelValue', event.target.value);
    },
  },
};
</script>
